import { render, staticRenderFns } from "./minus.vue?vue&type=template&id=7ebeea70&"
import script from "./minus.vue?vue&type=script&lang=js&"
export * from "./minus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ebeea70')) {
      api.createRecord('7ebeea70', component.options)
    } else {
      api.reload('7ebeea70', component.options)
    }
    module.hot.accept("./minus.vue?vue&type=template&id=7ebeea70&", function () {
      api.rerender('7ebeea70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/minus.vue"
export default component.exports